const JWT_COOKIE_NAME = "jwtToken_v2";
const EXT_SESSIONID_COOKIE_NAME = "extSessionId";
export const GlobalConfig = {
    config: {
        apiUrl: "",
        siteID: 0,
        apiVersion: "v2",
        operatorAuthTokenId: "",
        applicationType: 0,
        domainID: "0",
        timeControl: undefined,
        initialTime: undefined,
        cookieDomain: undefined,
        jwtCookieName: JWT_COOKIE_NAME,
        extSessionCookieName: EXT_SESSIONID_COOKIE_NAME,
        pageMethods: {
            SeamlessTokenLogin: () => { },
            JwtTokenLogin: () => { },
            LoginTwoStep: () => { }
        },
        player: {
            onLogout: {},
            onSecondStepLoginFailed: {},
            onNotLoggedIn: {},
            onTokenLoginReceived: {},
            onOneTimeTokenReceived: {},
            onSessionKeepAlive: {},
            onJwtLoginReceived: {},
            onTwoStepLoginContinue: {},
            loadUser: () => { },
            processLoginError: () => { },
            legacyWalletTokenLogin: () => { },
            logout: () => { },
            oneTimeTokenLoginFailed: () => { },
            showSessionExpired: () => { },
            continueLogin: () => { },
            proceedToSecondStep: () => { },
            processLoginApiError: () => { }
        },
        getIovationKey: () => "",
        secure: false
    }
};
//# sourceMappingURL=config.js.map